import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { ENDPOINTS } from "../Helper/endpoints";
import Swal from "sweetalert2";
import Footer from "./Footer";
import html2pdf from "html2pdf.js";

const Report = () => {
  const [selectedVendor, setSelectedVendor] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [vendors, setVendors] = useState([]);
  const [reportData, setReportData] = useState([]);
  // const [selectedYear, setSelectedYear] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [reportType, setReportType] = useState("");
  // const [organizationLogo, setOrganizationLogo] = useState("/default-logo.jpg");

  const [formData, setFormData] = useState({
    vendorPid: "",
    userPid: "",
    organizationsPid: "",
  });

  const financialYears = [
    "2023-2024",
    "2024-2025",
    "2025-2026",
    "2026-2027",
  ];

  const getCookie = (name) => {
    const cookies = document.cookie.split("; ");
    for (let c of cookies) {
      const [key, value] = c.split("=");
      if (key === name) return decodeURIComponent(value);
    }
    return null;
  };

  //  FIXED
  const getUserDataFromCookies = useCallback(() => {
    const data = getCookie("userSession");
    if (data) {
      try {
        const parsed = JSON.parse(data);
        // setOrganizationLogo(
        //   parsed?.data?.organization_logo || "/default-logo.jpg"
        // );

        return {
          userPid: parsed.data.user_info.user_pid,
          organizationsPid: parsed.data.user_info.organizations_pid,
        };
      } catch {
        return { userPid: "", organizationsPid: "" };
      }
    }
    return { userPid: "", organizationsPid: "" };
  }, []);

  useEffect(() => {
    const { userPid, organizationsPid } = getUserDataFromCookies();

    setFormData((prev) => ({
      ...prev,
      userPid,
      organizationsPid,
    }));
  }, [getUserDataFromCookies]);

  useEffect(() => {
    const { organizationsPid } = getUserDataFromCookies();

    if (organizationsPid) {
      axios
        .get(ENDPOINTS.VENDOR_INFO, {
          params: { organization_pid: organizationsPid },
        })
        .then((res) => setVendors(res.data.data))
        .catch((err) => console.error(err));
    }
  }, [getUserDataFromCookies]);

  const handleVendorChange = (pid) => {
    setSelectedVendor(pid);
    setFormData((prev) => ({ ...prev, vendorPid: pid }));
  };

  const handleGenerateReport = () => {
    if (!selectedVendor || !fromDate || !toDate) {
      Swal.fire("Error", "Fill all fields", "error");
      return;
    }

    axios
      .get(ENDPOINTS.PR_REPORT, {
        params: {
          organization_pid: formData.organizationsPid,
          vendor_pid: selectedVendor,
          from_date: fromDate,
          to_date: toDate,
        },
      })
      .then((res) => {
        if (res.data.status) {

          //remove duplicate based on pr_no
          const uniqueData = res.data.data.filter(
            (item,index,self)=>
              index === self.findIndex((t) => t.pr_no === item.pr_no) 
          )
          setReportData(uniqueData);
          setShowPopup(false);
        } else {
          setReportData([]);
        }
      });
  };

  const exportToPDF = () => {
    const element = document.getElementById("pdf-content");
    if (!element) return;

    html2pdf().from(element).save("Report.pdf");
  };

  const handleYearChange = (year) => {
    const [start, end] = year.split("-");
    setFromDate(`${start}-04-01`);
    setToDate(`${end}-03-31`);
  };

  return (
    <>
      <div className="report">
        <h2>Generate Report</h2>
        
        {/* buttons */}
        <button
          className={reportType === "custom" ? "active" : ""}
          onClick={() => { setReportType("custom"); setShowPopup(true); }}
        >
          Custom Date
        </button>

        <button
          className={reportType === "financial" ? "active" : ""}
          onClick={() => { setReportType("financial"); setShowPopup(true); }}
        >
          Financial Year
        </button>

        {/* Popup */}
        {showPopup && (
          <div className="popup-overlay">
            <div className="popup">
              <h3>Select Details</h3>

              <select onChange={(e) => handleVendorChange(e.target.value)}>
                <option value="">Select Vendor</option>
                {vendors.map((v) => (
                  <option key={v.pid} value={v.pid}>
                    {v.name}
                  </option>
                ))}
              </select>

              {reportType === "custom" ? (
                <>
                  <input type="date" onChange={(e) => setFromDate(e.target.value)} />
                  <input type="date" onChange={(e) => setToDate(e.target.value)} />
                </>
              ) : (
                <select onChange={(e) => handleYearChange(e.target.value)}>
                  <option>Select Year</option>
                  {financialYears.map((y) => (
                    <option key={y}>{y}</option>
                  ))}
                </select>
              )}

              <button onClick={handleGenerateReport}>Generate</button>
              <button onClick={() => setShowPopup(false)}>Close</button>
            </div>
          </div>
        )}

        {/* Table */}
        {reportData.length > 0 && (
          <div>
            <button className="pdf-button" onClick={exportToPDF}>
              Export PDF
            </button>

            <table>
              <thead>
                <tr>
                  <th>PR No</th>
                  <th>Date</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {reportData.map((r) => (
                  <tr key={r.id}>
                    <td>{r.pr_no}</td>
                    <td>{r.pr_date}</td>
                    <td>{r.net_payable}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* PDF */}
        <div id="pdf-content">
          <h2>Report</h2>
          <table>
            <thead>
              <tr>
                <th>PR No</th>
                <th>Date</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {reportData.map((r) => (
                <tr key={r.id}>
                  <td>{r.pr_no}</td>
                  <td>{r.pr_date}</td>
                  <td>{r.net_payable}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Footer />

      {/* ✅ CSS */}
     <style>{`
.report {
  padding: 20px;
  font-family: Arial;
  position: relative;
  min-height: 100vh;
}

/* Buttons */
.report button {
  margin: 5px;
  padding: 10px 18px;
 background-color: #191056;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
}

.report button:hover {
  background: #1a5edb;
}

.report button.active {
  background-color: #191056;
}

/* 🔥 POPUP FIX */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;   /* IMPORTANT FIX */
}

.popup {
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  width: 320px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.3);
  text-align: center;
}

.popup h3 {
  margin-bottom: 15px;
}

.popup input,
.popup select {
  width: 100%;
  margin: 10px 0;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

/* Buttons inside popup */
.popup button {
  margin-top: 10px;
  width: 100%;
}

/* Table */
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

th, td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: center;
}

th {
  background-color: #191056;
  color: white;
}

/* PDF button */
.pdf-button {
  background-color: #191056;
  color: white;
  padding: 10px 15px;
  margin-top: 10px;
  border-radius: 6px;
}

/* Hide PDF section */
#pdf-content {
  display: none;
}
`}</style>
    </>
  );
};

export default Report;